import React from 'react';
import classnames from 'classnames';

export interface INumberInputProps {
  value: string;
  label?: string;
  id: string;
  className?: string;
  labelClassName?: string;
  inputClassName?: string;
  labelStyle?: React.CSSProperties;
  disabled?: boolean;
  errorMessage?: string | null;
  errorClassName?: string;
  warning?: boolean;
  placeholder?: string;
  onChange: (value: string) => void;
}

export const NumberInput = (props: INumberInputProps) => {
  const {
    label,
    id,
    className,
    warning,
    errorMessage,
    labelClassName,
    inputClassName,
    errorClassName,
    onChange,
    placeholder,
    ...rest
  } = props;
  const isError = !!errorMessage || errorMessage === '';
  const inputClassname = classnames(
    'default:text-15px default:leading-18px py-7px px-10px default:font-pt-sans outline-none default:placeholder:italic',
    inputClassName,
    {
      'default:border-gray-40 default:bg-ivory': !isError && !props.disabled,
      'border-red-95 bg-red-25': isError && !props.disabled,
      'border-yellow-30': !!warning,
      'text-black border border-solid': !props.disabled,
      'default:text-gray-100 border border-gray-20 bg-ivory': props.disabled,
    }
  );

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    onChange(newValue);
  };

  const handleKeyDown = event => {
    if (!/^\d$/.test(event.key) && event.key !== 'Backspace') {
      event.preventDefault();
    }
  };

  return (
    <div className={`flex flex-col ${className ?? ''}`}>
      {label && (
        <label
          style={props.labelStyle}
          className={classnames('text-black font-pt-sans text-13px leading-17px tracking-2xs mb-[5px]', labelClassName)}
          htmlFor={id}
        >
          {label}
        </label>
      )}
      <input
        placeholder={placeholder}
        className={inputClassname}
        id={id}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        {...rest}
      />
      {errorMessage && (
        <p className={`text-red-95 text-13px leading-2xs font-pt-sans mt-5px mb-0 ${errorClassName ?? ''}`}>
          {errorMessage}
        </p>
      )}
    </div>
  );
};
